import validate from './utils/validate.js';

export default (() => {
    const listeners = new Map();

    const handleKeyUp = event => {
        if (event.key === 'Escape' || event.key === 'Esc') {
            for (const [element, callback] of listeners.entries()) {
                callback(event, element);
            }
        }
    };

    return {
        created() {
            document.addEventListener('keyup', handleKeyUp);
        },

        beforeMount(el, binding) {
            if (!validate(binding)) return;

            listeners.set(el, binding.value);
        },

        updated(el, binding) {
            if (!validate(binding)) return;

            listeners.set(el, binding.value);
        },

        unmounted(el) {
            listeners.delete(el);
            document.removeEventListener('keyup', handleKeyUp);
        },
    };
})();
